import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HeroHeader from "../HeadersComponents/HeroHeader";
import ServicePageParagraphs from "../ParagraphComponents/ServicePageParagraphs";
import ServiceSectionButton from "../ButtonComponents/ServiceSectionButton";
import HeroImage from "../HeroImage/HeroImage";
import "./HeroSection.scss";
import "animate.css";

const HeroSection = ({
  className,
  firstHeaderText,
  secondHeaderText,
  textArr,
  textColor,
  textAlign,
  btnPath,
  btnOnHover,
  btnTitle,
  btnAlign,
  btnMarginBottom,
  primaryImg,
  secondaryImg,
  paddingLeftImgCol,
  heroAnimation,
}) => {
  return (
    <section className={`${className} hero-component-wrapper`}>
      <Container>
        <Row>
          <Col>
            <HeroHeader
              className="firstHeader animate__animated animate__fadeInLeft animate__delay-0.8s"
              colorType="light"
              headerText={firstHeaderText}
            />
            <HeroHeader
              className="secondHeader animate__animated animate__fadeInRight animate__delay-0.8s"
              colorType="dark"
              headerText={secondHeaderText}
            />
            <ServicePageParagraphs
              textArr={textArr}
              textColor={textColor}
              textAlign={textAlign}
            />
            <ServiceSectionButton
              path="#calendly"
              onHover={btnOnHover}
              title={btnTitle}
              buttonAlign={btnAlign}
              marginBottom={btnMarginBottom}
            />
          </Col>
          <Col>
            <HeroImage
              primaryImg={primaryImg}
              secondaryImg={secondaryImg}
              paddingLeft={paddingLeftImgCol}
              animationData={heroAnimation}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
